import React, { useState, useEffect } from "react";
import {
  Modal,
  Button,
  message,
  Upload,
  Row,
  Col,
  Select,
  Spin,
  Drawer,
} from "../../../../components/common/utils/antd-imports/AntdImports";
import "./BulkUploadModal.css";
import { ReactComponent as DropExcelIcon } from "../../../../assests/drop-excel-icon.svg";
import { ReactComponent as ExcelIcon } from "../../../../assests/vscode-icons_file-type-excel.svg";
import { useDispatch, useSelector } from "react-redux";
import { uploadCSV } from "../../../../store/thunks/seller-thunks/SellerThunk";
import DigitalStaticCSV from "../../../../assests/csv/BU-Template-Digital-Static.csv";
import StaticCSV from "../../../../assests/csv/BU-Template-Static.csv";
import DigitalCSV from "../../../../assests/csv/BU-Template-Digital.csv";
import MediaCSV from "../../../../assests/csv/BU-Template-Media.csv";
import { useMediaQuery } from "react-responsive";
const BulkUploadModal = ({ bulkUpload, setBulkUpload }) => {
  const handleCancel = () => {
    setBulkUpload(false);
    setData([]);
  };
  const { Dragger } = Upload;
  const [uploading, setUploading] = useState("");
  const [progress, setProgress] = useState("");
  const [templateValue, setTemplateValue] = useState("");
  const [templateValueFlag, setTemplateValueFlag] = useState(false);
  const [data, setData] = useState([]);
  const dispatch = useDispatch();
  const isMobile = useMediaQuery({ maxWidth: 768 });
  const [status, setStatus] = useState(null);
  const handleUpload = () => {
    const formData = new FormData();
    formData.append("file", data[0].originFileObj);
    formData.append("type", templateValue);
    dispatch(uploadCSV(formData)).then((res) => {
      setStatus(res?.payload?.status);
    });
  };
  const handleChange = (value) => {
    setTemplateValueFlag(false);
    setTemplateValue(value);
  };
  const { error, successMessages, errorMessages, isLoading } = useSelector(
    (state) => state.sellerCampaigns
  );
  const handleFileChange = (info) => {
    const file = info?.fileList.slice(-1);
    setData(file);
    const { status, name, percent } = info.file;

    if (status === "uploading") {
      setUploading(true);
      setProgress(percent || 0);
    } else if (status === "done") {
      message.success(`${name} file uploaded successfully.`);
      setUploading(false);
      setProgress(100);
    } else if (status === "error") {
      message.error(`${name} file upload failed.`);
      setUploading(false);
      setProgress(0);
    }
  };
  const downloadTemplateType = () => {
    if (templateValue === "") {
      setTemplateValueFlag(true);
    }
    // Create a temporary link element
    const link = document.createElement("a");
    switch (templateValue) {
      case "Static":
        link.href = StaticCSV;
        link.download = "BU-Template-Static.csv";
        break;
      case "Digital":
        link.href = DigitalCSV;
        link.download = "BU-Template-Digital.csv";
        break;
      case "Digital/Static":
        link.href = DigitalStaticCSV;
        link.download = "BU-Template-Digital-Static.csv";
        break;

      case "Media":
        link.href = MediaCSV;
        link.download = "BU-Template-Media.csv";
        break;
    }
    link.click();
    if (templateValue) message.success("Downloading CSV file...");
  };

  const getFileSize = (sizeInBytes) => {
    let readableSize = null;
    if (sizeInBytes < 1024) {
      return (readableSize = `${sizeInBytes} B`);
    } else if (sizeInBytes < 1024 * 1024) {
      return (readableSize = `${(sizeInBytes / 1024).toFixed(2)} KB`);
    } else {
      return (readableSize = `${(sizeInBytes / (1024 * 1024)).toFixed(2)} MB`);
    }
  };
  const renderStatusMessage = (progress) => {
    if (progress === 0) {
      return "Missing mandatory fields may result in skipped products during the upload process.";
    } else if (progress > 0 && progress < 100) {
      return "Once uploaded, the system will check your file for missing mandatory fields like product name, price, or quantity.";
    }

    if (successMessages && successMessages?.length > 0 && !isLoading) {
      return successMessages?.map((message, index) => {
        return (
          <div>
            <ul
              key={index}
              style={{
                color:
                  status == 1
                    ? "var(--Colors-Primary-500,rgb(21, 210, 4))"
                    : "#d2042d",
              }}
            >
              <li>{message}</li>
            </ul>
          </div>
        );
      });
    }
    if (errorMessages && errorMessages?.length > 0 && !isLoading) {
      return errorMessages?.map((message, index) => {
        return (
          <>
            <ul
              key={index}
              style={{ color: "var(--Colors-Primary-500, #d2042d)" }}
            >
              <li>{message}</li>
            </ul>
          </>
        );
      });
    }
  };

  const sharedContent = (
    <div>
      <h1 className="steps">Steps</h1>
      <ol style={{ fontFamily: "Roboto" }}>
        <li>Ensure your Excel file matches the provided template.</li>
        <li>Fill in all mandatory fields (marked in the template).</li>
        <li>Upload your file to add the products.</li>
        <li>Manually upload images after adding products to AMP.</li>
      </ol>
      <Row>
        <Col span={12}>
          <Select
            className="product-select"
            style={{ width: "96%" }}
            defaultValue="Format Type"
            onChange={handleChange}
            options={[
              { value: "Static", label: "Static" },
              { value: "Digital", label: "Digital" },
              { value: "Digital/Static", label: "Static/Digital" },
              { value: "Media", label: "Media" },
            ]}
          />
          {templateValueFlag && (
            <div className="error-header" style={{ marginTop: "0.5rem" }}>
              Please select a format type.
            </div>
          )}
        </Col>
        <Col span={6}>
          <Button className="download-btn" onClick={downloadTemplateType}>
            Download Template
          </Button>
        </Col>
      </Row>
      {data.length ? (
        <div className="uploaded-section">
          <div style={{ display: "flex" }}>
            <div className="file-details">
              <ExcelIcon className="campaign-icons" />
            </div>
            <div>
              <span className="file-name">
                {data[0].name} <br />{" "}
              </span>
              <span className="size-text">{getFileSize(data[0].size)}</span>
            </div>
          </div>
        </div>
      ) : (
        <div className="dragger">
          <Dragger
            accept=".csv"
            onChange={handleFileChange}
            beforeUpload={() => false} // Disable auto upload
            showUploadList={{ showRemoveIcon: true }}
          >
            <DropExcelIcon />
            <div style={{ fontFamily: "Roboto" }}>
              Drag & drop your excel here
            </div>
            <div style={{ fontFamily: "Roboto" }}>or</div>
            <Button className="browse-button billboard-button-2">Browse</Button>
          </Dragger>
        </div>
      )}
      {errorMessages && errorMessages?.length > 0 && (
        <div className="error-header" style={{ marginBottom: "1rem" }}>
          Uh-oh! We found some issues in your file. Let's review the details
          below
        </div>
      )}
      <div className={` help-text ${progress === 0 ? "bg-help-text" : ""}`}>
        {renderStatusMessage(progress)}
      </div>
    </div>
  );
  useEffect(() => {
    renderStatusMessage(progress);
  }, [data, error, progress, renderStatusMessage]);
  return (
    <div>
      {isMobile ? (
        <Drawer
          maskProps={{ style: { backgroundColor: "rgba(0, 0, 0, 0.1)" } }}
          open={bulkUpload}
          destroyOnClose={true}
          className="bulk-upload"
          title={
            <span className="bulk-upload-header">
              Bulk Upload Your Products
            </span>
          }
          okText="Upload"
          closable={false}
          onCancel={handleCancel}
          width={"638px"}
          footer={
            <>
              {isLoading ? (
                <div className="loading-css">
                  <Spin size="large" fullscreen />
                </div>
              ) : (
                <Row justify="end">
                  <Button
                    className={
                      "footer-btns cancel-btn" +
                      (data?.length ? " enable-btn" : "")
                    }
                    onClick={handleCancel}
                  >
                    Cancel
                  </Button>
                  <Button
                    className={
                      "footer-btns upload-btn billboard-button-2" +
                      (data?.length ? " enable-btn" : "")
                    }
                    onClick={handleUpload}
                    disabled={!data?.length || !templateValue}
                  >
                    {" "}
                    Upload
                  </Button>
                </Row>
              )}
            </>
          }
        >
          {sharedContent}
        </Drawer>
      ) : (
        <Modal
          maskProps={{ style: { backgroundColor: "rgba(0, 0, 0, 0.1)" } }}
          open={bulkUpload}
          destroyOnClose={true}
          className="bulk-upload"
          title={
            <span className="bulk-upload-header">
              Bulk Upload Your Products{" "}
            </span>
          }
          okText="Upload"
          closable={false}
          onCancel={handleCancel}
          width={"638px"}
          footer={
            <>
              {isLoading ? (
                <div className="loading-css">
                  <Spin size="large" fullscreen />
                </div>
              ) : (
                <Row justify="end">
                  <Button
                    className={
                      "footer-btns cancel-btn" +
                      (data?.length && templateValue ? " enable-btn" : "")
                    }
                    onClick={handleCancel}
                  >
                    Cancel
                  </Button>
                  <Button
                    className={
                      "footer-btns upload-btn billboard-button-2" +
                      (data?.length && templateValue ? " enable-btn" : "")
                    }
                    onClick={handleUpload}
                    disabled={!data?.length || !templateValue}
                  >
                    {" "}
                    Upload
                  </Button>
                </Row>
              )}
            </>
          }
        >
          {sharedContent}
        </Modal>
      )}
    </div>
  );
};

export default BulkUploadModal;
